import React, { Component } from 'react'
import animateScrollTo from 'animated-scroll-to'
import './styles/style.css'

class Header extends Component {

    constructor(props) {
        super(props)

        this.state = {
            activeId: null
        }
    }

    menuSelect(item) {
        if (item.id && item.id !== '') {
            const target = this.props.appRootView.refs[item.id]
            if (target && !item.noscroll) {
                console.log(target)
                animateScrollTo(target.offsetTop,{
                    onComplete: ()=>{
                        this.setState({
                            activeId: item.id
                        })
                    }
                })
            } else if (target && item.noscroll) {
                this.setState({
                    activeId: item.id
                })
            }
        }
    }

    componentDidMount() {
        window.onscroll = (e) => {
            const refs = this.props.appRootView.refs
            for (let key in refs) {
                const target = refs[key]
                if (target) {
                    const begin = target.offsetTop
                    const end = begin + target.offsetHeight
                    const scrollOffset = window.scrollY + (target.offsetHeight/2)

                    if (scrollOffset > begin && scrollOffset <= end ) {
                        this.menuSelect({
                            id: key,
                            noscroll: true
                        })
                    }
                }
            }
        }
    }

    renderMenuItems() {

        if (!this.props.menuItems || this.props.menuItems.length === 0) {
            return null
        }

        return (
            this.props.menuItems.map((item, i) => {
                if (item.id === this.state.activeId || (i === 0 && !this.state.activeId)) {
                    return (
                        <div
                            key={`MenuItem_${item.id}`}
                            ref={`MenuItem_${item.id}`}
                            className="MenuItemWrapper MenuItemWrapperActive"
                            onClick={this.menuSelect.bind(this, item)}
                        >
                            <span className="MenuItemText">
                                {item.title}
                            </span>
                            <div className="ActiveMenuUnderline" />
                        </div>
                    )
                } else {
                    return (
                        <div
                            key={`MenuItem_${item.id}`}
                            ref={`MenuItem_${item.id}`}
                            className="MenuItemWrapper"
                            onClick={this.menuSelect.bind(this, item)}

                        >
                            <span className="MenuItemText">
                                {item.title}
                            </span>
                        </div>
                    )
                }

            })
        )
    }

    render() {

        return (
            <div className="HeaderWrapper">
                <div className="HeaderContent">
                    <div className="LogoWrapper">

                    </div>
                    <div className="MenuWrapper">
                        {this.renderMenuItems()}
                    </div>
                    <a href="tel:89643422699" className="CallButtonWrapper">
                    </a>
                </div>
            </div>
        )
    }
}

export default Header


// WEBPACK FOOTER //
// ./src/Components/Header/index.js